import variance from "./variance";

export default function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/deviation.js
// module id = 104
// module chunks = 0 1 2 3 4